import { defineComponent as n } from "vue";
import r from "./index139.js";
const o = n({
  name: "E_Resultlist_Disturber_Ad_3",
  components: {
    MsAdPlace: r
  },
  props: {
    cmsContent: {
      type: Object,
      required: !0
    },
    isInDisturber: Boolean
  },
  setup(e) {
    function t() {
      return e.cmsContent.properties["meinestadt/advertising/types#size_maxHeight"];
    }
    return {
      getMaxHeight: t
    };
  }
});
export {
  o as default
};
